// src/components/HowThisWorksSection.jsx
import React from "react";
import { Target, MessageSquare, Users } from "lucide-react";

const HOW_IT_WORKS_ITEMS = [
    {
        title: "A real diagnosis, not a template",
        description: "I look at what's actually happening in your business, not a generic framework applied from outside.",
        icon: Target,
    },
    {
        title: "Short, focused working sessions",
        description: "Regular conversations to pressure-test what's working, fix what isn't, and keep the next move clear.",
        icon: MessageSquare,
    },
    {
        title: "You stay close, your team builds it",
        description: "I diagnose, then work closely alongside your team through implementation.",
        icon: Users,
    },
];

export default function HowThisWorksSection() {
    return (
        <section
            id="how-this-works"
            className="px-6 md:px-12 lg:px-36 py-20"
            style={{ backgroundColor: "var(--bg-base)" }}
        >
            <div className="max-w-[900px] mx-auto">

                {/* Section heading */}
                <h2 className="text-3xl md:text-4xl font-semibold mb-12 text-center text-[var(--text-primary)]">
                    How This Works
                </h2>


                {/* Cards grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {HOW_IT_WORKS_ITEMS.map((item, index) => {
                        const Icon = item.icon;
                        return (
                            <div
                                key={index}
                                className="rounded-xl border p-6 h-full"
                                style={{
                                    backgroundColor: "var(--bg-surface)",
                                    borderColor: "rgba(26,30,46,0.08)",
                                }}
                            >
                                <div
                                    className="mb-4"
                                    style={{ color: "var(--color-primary)" }}
                                >
                                    <Icon size={24} strokeWidth={2} />
                                </div>

                                <p className="font-medium text-[var(--text-primary)] mb-2">
                                    {item.title}
                                </p>

                                <p className="text-base text-left text-[var(--text-secondary)] leading-relaxed">
                                    {item.description}
                                </p>
                            </div>
                        );
                    })}
                </div>

            </div>
        </section>
    );
}
